import QuoteStepBase from '../../components/QuoteStepBase'
import 'react-input-checkbox/lib/react-input-checkbox.min.css';
import { IQuoteStepComponentProps, IQuoteStepState } from '../../components/interfaces';
import { IAppState } from '../../state/interfaces';
import { connect } from "react-redux";
import Utilities from '../../classes/Utilities';
import { PATHS, FULL_QUOTE_STEPS } from '../../AppConstants';
import { QuoteStep } from "./QuoteStepLayout";
import React from 'react';
import ButtonContinue from '../../components/ButtonContinue';
import { quoteStepChanged } from '../../state/appActions';

class GoodToGo extends QuoteStepBase<IQuoteStepComponentProps, IQuoteStepState> {
    constructor(props: IQuoteStepComponentProps) {
        super(props);
        this.next = this.next.bind(this);

        this.state = {
            updatingStore: false,
            errors: null
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();

        this.setState({ ...this.state, updatingStore: false, errors: null });
    }

    next() {
        this.props.history.push(Utilities.formatUrl(PATHS.FQ_ESIGNATURE, ""));
    }

    render() {
        return (
            <QuoteStep id="goodtogo">
                <div className="titleArea"><h5>You are Covered and Good To Go</h5></div>

                <div className="choice">
                    {
                        <p className="text-center">
                            Thank you for purchasing your policy with Bravo General; you are covered and good to go! 
                            Please click continue to finalize your documents, and get your instant PROOF OF COVERAGE!
                        </p>
                    }
                    <div className="text-center">
                        <ButtonContinue
                            label="Continue"
                            onClick={this.next} />
                    </div>
                </div>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IQuoteStepComponentProps) => {
    return ownProps;
};

let mapDispatch = (dispatch: any) => {
    return {
        reportCurrentStep: () => dispatch(quoteStepChanged(FULL_QUOTE_STEPS.FINALIZE))
    };
};

export default connect(mapProps, mapDispatch)(GoodToGo);